import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BaseTableFilters } from "@src/types";

export interface ResourcePlanOverviewFilters extends BaseTableFilters {
  project: string[];
  phase: string[];
  country: string[];
  region: string[];
  projectManager: string[];
}

export interface ResourcePlanOverviewState {
  quickFilter: string;
  customTableFilters: ResourcePlanOverviewFilters;
}

const initialState: ResourcePlanOverviewState = {
  quickFilter: "",
  customTableFilters: {
    project: [],
    phase: [],
    country: [],
    region: [],
    projectManager: [],
  },
};

const resourcePlanOverviewSlice = createSlice({
  name: "resourcePlanOverviewSlice",
  initialState,
  reducers: {
    /**
     * Sets the quick filter for the resource plan overview.
     *
     * @param state The current state of the resource plan overview.
     * @param quickSearch The quick search string to filter by.
     */
    setResourcePlanOverviewQuickFilter: (
      state: ResourcePlanOverviewState,
      quickSearch: PayloadAction<string>
    ): void => {
      state.quickFilter = quickSearch.payload;
    },

    /**
     * Sets the custom table filters for the resource plan overview.
     *
     * @param state The current state of the resource plan overview.
     * @param customTableFilters The custom filters to apply to the table (e.g., project, phase, country, region, project manager).
     */
    setResourcePlanOverviewTableFilter: (
      state: ResourcePlanOverviewState,
      customTableFilters: PayloadAction<ResourcePlanOverviewFilters>
    ): void => {
      state.customTableFilters = customTableFilters.payload;
    },
  },
});

export const {
  setResourcePlanOverviewQuickFilter,
  setResourcePlanOverviewTableFilter,
} = resourcePlanOverviewSlice.actions;

export default resourcePlanOverviewSlice;
